import { Component, EventEmitter } from '@angular/core'
import { ICellRendererAngularComp } from 'ag-grid-angular'
import { VersaoService } from './versao.service'
import { Router } from '@angular/router'

import{ AcessoApiService } from '../../../acessoApi.service'


@Component({
  selector: 'btns-cell2',
  templateUrl: './botoesGridVersao.component.html', 
  styles: [
    `.estilo-botao {
        margin-right: 5px;
        border: none;
        background-color: white;
    }`
  ]
})
export class BotoesGridVersaoRender implements ICellRendererAngularComp{
    public params: any
    public id: any
    emitirNovaCategoria =  new EventEmitter();
    constructor(private acessoService: AcessoApiService,private rotas: Router, private acessoVersao: VersaoService){}

    agInit(params: any): void {
        this.params = params;
    }

    public editarVersao() {
       this.acessoVersao.setVersao(parseInt(`${this.params.data.ID_INST}`));
       this.rotas.navigate(["/administrativo/versao/editar"])
       
    }

    public excluirVersao() {
        this.acessoVersao.setVersao(parseInt(`${this.params.data.ID_INST}`))
    }

    refresh(): boolean {
        return true;
    }


}


// WEBPACK FOOTER //
// ./src/app/pages/administracao/versao/botoesGridVersao.component.ts